import type { Correction } from './tutor/grammarChecker';

/** The three top-level screens, mirroring the Android bottom navigation bar. */
export type Tab = 'talk' | 'practice' | 'progress';

export type ChatRole = 'tutor' | 'learner';

/** One bubble in the conversation. */
export interface ChatMessage {
  id: number;
  role: ChatRole;
  text: string;
  praise?: string | null;
  corrections?: Correction[];
  correctedSentence?: string | null;
  tip?: string | null;
}

/** A correction kept for later review on the Progress screen. */
export interface SavedCorrection {
  rule: string;
  original: string;
  corrected: string;
  explanation: string;
}

/** How often one grammar rule has fired. */
export interface MistakeCount {
  rule: string;
  label: string;
  count: number;
}

/** Everything the Progress screen shows. */
export interface ProgressSnapshot {
  totalMessages: number;
  cleanMessages: number;
  totalCorrections: number;
  sessions: number;
  streakDays: number;
  practiceAttempts: number;
  practiceBest: number;
  practiceAverage: number;
  /** Share of messages that needed no correction at all, 0..100. */
  accuracy: number;
  topMistakes: MistakeCount[];
  recentCorrections: SavedCorrection[];
}

export const EMPTY_PROGRESS: ProgressSnapshot = {
  totalMessages: 0,
  cleanMessages: 0,
  totalCorrections: 0,
  sessions: 0,
  streakDays: 0,
  practiceAttempts: 0,
  practiceBest: 0,
  practiceAverage: 0,
  accuracy: 0,
  topMistakes: [],
  recentCorrections: [],
};
